import { render } from "./List.vue?vue&type=template&id=5a127204&ts=true"
import script from "./List.vue?vue&type=script&lang=tsx"
export * from "./List.vue?vue&type=script&lang=tsx"

import "./List.vue?vue&type=style&index=0&id=5a127204&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__